import React, { useEffect, useState } from 'react';
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      const difference = midnight.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-mystic-surfaceDark border-b border-gold-dark/30 py-2 px-4 text-center" data-id="element-46">
      <p className="text-gold-light text-sm md:text-base font-outfit font-medium tracking-wide" data-id="element-47">
        OFERTA ESPECIAL SOLO POR HOY{' '}
        <span className="hidden md:inline mx-2" data-id="element-48">|</span>
        <br className="md:hidden" data-id="element-49" />
        <span className="text-text-primary ml-2" data-id="element-50">
          Finaliza en: {formatTime(timeLeft.hours)}:
          {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)} horas
        </span>
      </p>
    </div>;
};